import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import useTranslate from '../../customHooks/useTranslate';
import useUserProfile from '../../customHooks/useUserProfile';

const CardTitle = props => {
    const {
        title = '',
        onChangeViewMode,
        isEditButtonVisible = true,
        label = '',
    } = props;
    const labelText = useTranslate(label) || '';
    const editText = useTranslate('edit');
    const { readOnlyUser } = useUserProfile();

    return (
        <div className='card__title'>
            <Tooltip title={labelText} placement='top' arrow>
                <h2 className='card__title-text'>{useTranslate(title)}</h2>
            </Tooltip>
            {!readOnlyUser && isEditButtonVisible && (
                <Tooltip title={editText} placement='top' arrow>
                    <IconButton onClick={onChangeViewMode}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>
            )}
        </div>
    );
};

export default CardTitle;
